import { render, staticRenderFns } from "./HomeIntroStars.vue?vue&type=template&id=0ca5391a&scoped=true&"
import script from "./HomeIntroStars.vue?vue&type=script&lang=js&"
export * from "./HomeIntroStars.vue?vue&type=script&lang=js&"
import style0 from "./HomeIntroStars.vue?vue&type=style&index=0&id=0ca5391a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca5391a",
  null
  
)

export default component.exports